import VehicleTableContainer from '../../VehicleTable/VehicleTableContainer';
import useColumnsLeadsLogs from '../tableColumns/useColumnsLeadsLogs';
import useLeadsStore from '../../../store/LeadsStore';
import _ from 'lodash';
import ErrorBoundary from '../../ErrorBoundary/ErrorBoundary';
import { useQuery } from "@tanstack/react-query";
import { useApiClient } from '../../../hooks/useApiClient';
import { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const LeadCallsLog = () => {
  const { t } = useTranslation();
  const { apiClient, handleApiResponse } = useApiClient();
  const { activeLead, setCallCounter } = useLeadsStore()

  const { data: leadCalls, isPending } = useQuery({
    queryKey: ['lead_calls_log', activeLead?.Id],
    enabled: !!activeLead?.Id,
    queryFn: async () => {
      const callLogs = await handleApiResponse(apiClient.leadsControllerService.getCalls(activeLead?.Id));
      const counter = callLogs.reduce((count, log) => count + (!log.Risposta ? 1 : 0), 0);
      setCallCounter(counter);
      return callLogs;
    },
    // staleTime: 1000 * 60 * 5,
    // refetchOnWindowFocus: false,
    // retry: false,
    // refetchOnMount: false
  });

  const rawColumns = useColumnsLeadsLogs();
  const columns = useMemo(() => rawColumns, [rawColumns]);
  const data = useMemo(() => leadCalls ?? [], [leadCalls]);

  return (
    <div className='mb-5 mt-3'>
      <Row>
        <Col md={6} className="display-6 mb-3">
          {t('leads_log_interactions')}
        </Col>
      </Row>
      <ErrorBoundary>
        <VehicleTableContainer
          columns={columns}
          data={data}
          hasFilters={false}
          loading={isPending}
          pageSize={5}
          skeletonProps={{ cols: 4, rows: 1 }}
        />
      </ErrorBoundary>
      {/* )}  */}

    </div>
  );
};

export default LeadCallsLog;
